const TMDB_BASE_URL = 'https://api.themoviedb.org';
const TMDB_BASE_IMAGE_URL = 'https://image.tmdb.org/t/p/original';
const Authorization = "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJiN2I2NzA5ZTlhMmE3ZjgyZjFiMzNkOWI4Mjk4OWZlYiIsIm5iZiI6MTc0Nzk4MDg2MS42Mywic3ViIjoiNjgzMDEyM2Q2MzY4NzAyYTIxYjZhNjgyIiwic2NvcGVzIjpbImFwaV9yZWFkIl0sInZlcnNpb24iOjF9.TlVECH200O4jK56C0g6abWv5uTSrPhvCrGe2GKdhF8g";
const API_KEY = " b7b6709e9a2a7f82f1b33d9b82989feb";

const API_VER_TMDB = {
    VERSION : `${TMDB_BASE_URL}/3`,
}

const ROUTES_TMDB = {
    DISCOVER : `${API_VER_TMDB.VERSION}/discover`,
    FIND : `${API_VER_TMDB.VERSION}/find`,
    SEARCH : `${API_VER_TMDB.VERSION}/search`,
    CREDIT : `${API_VER_TMDB.VERSION}/credit`,
}

const ENDPOINTS_TMDB = {
    MOVIE : `${ROUTES_TMDB.DISCOVER}/movie`,
    MOVIE_DETAIL : `${API_VER_TMDB.VERSION}/movie`,
    TV_DETAIL : `${API_VER_TMDB.VERSION}/tv`,
    SEARCH_MOVIE_BY_TITLE : `${ROUTES_TMDB.SEARCH}/movie`,
    SEARCH_TV_SHOW_BY_TITLE : `${ROUTES_TMDB.SEARCH}/tv`,
    UPCOMING : `${ROUTES_TMDB.DISCOVER}/movie/upcoming`,
    TOP_RATED : `${ROUTES_TMDB.DISCOVER}/movie/top_rated`,
    POPULAR : `${ROUTES_TMDB.DISCOVER}/movie/popular`,
};


export default {ENDPOINTS_TMDB,ROUTES_TMDB,TMDB_BASE_URL,Authorization,API_KEY};
